var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"army army_background"},[(_vm.role=== 'screen')?_c('AudioStart',{attrs:{"audio":"/2022/audio/einde-missie-2.mp3"}}):_vm._e(),_c('TussenStand',{attrs:{"role":_vm.role}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }